// extracted by mini-css-extract-plugin
export default {"container":"k8FAI ZdH1P","titleWrapper":"oz1vL","title":"m0VTl","priceMin":"ooWcW","list":"BtdgU","slide":"U2rSQ"};